import React from 'react';
import { Link } from 'react-router-dom';
import { useVersion } from '../contexts/VersionContext';
import useSectionViewTracking from '../hooks/useSectionViewTracking';
import styles from './AboutStudio.module.css';

export default function AboutStudio({ showTeamLink = false }) {
  const { isImprovedVersion } = useVersion();
  const sectionRef = useSectionViewTracking('about_stratmech_studios');

  return (
    <section
      ref={sectionRef}
      className={`${styles.aboutStudio} ${isImprovedVersion ? styles.aboutStudioImproved : ''}`}
      id="studio"
    >
      <div
        className={styles.backgroundLayer}
        aria-hidden="true"
        style={{ backgroundImage: 'url("/images/webp/HeroBG.webp")' }}
      ></div>
      <div className={styles.container}>
        <div className={styles.inner}>
          <h2 className={styles.title}>About StratMech Studios</h2>
          <div className={styles.divider} aria-hidden="true"></div>

          <div className={styles.copy}>
            <p className={styles.text}>
              <strong>StratMech Studios</strong> is an independent studio built around a love for <em>thoughtful, decision-driven strategy games</em> that reward patience, foresight, and commitment.
            </p>
            <p className={styles.text}>
              <Link to="/inceptum" className={styles.inlineLink}><strong>INCEPTUM: Dawn of Civilizations</strong></Link> is our debut title. What began as a focused passion project evolved through years of iteration, playtesting, and refinement. Every system, component, and detail was shaped so that no two playthroughs feel the same.
            </p>
            <p className={styles.closing}>
              We&apos;ve always felt that the best games stay with you long after the table is cleared.<br />
              <strong>We hope INCEPTUM leaves you with that same feeling.</strong>
            </p>
          </div>

          {showTeamLink && (
            <Link to="/about-us#team" className={styles.teamLink}>
              Meet the team behind INCEPTUM
              <span className={styles.teamLinkArrow} aria-hidden="true">&rarr;</span>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
